import { capitalizeFirstLetter } from "./Common/Utility";
import { Post } from "./Common/WebRequest";

async function handleRefreshToken() {
  try {
    const loginData = JSON.parse(localStorage.getItem("login"));
    if (!loginData?.token || !loginData?.refreshToken) {
      localStorage.removeItem("login");
      window.location.href = "/login";
      return null;
    }

    console.log(new Date().toUTCString() + ": Token refresh...");
    const request = { token: loginData.token, refreshToken: loginData.refreshToken };
    const response = await Post("Login/RefreshToken", request);

    if (response?.isSuccess && response?.token) {
      const displayUserName = capitalizeFirstLetter(response.userName ?? loginData.userName ?? "");
      const next = {
        isLogin: true,
        token: response.token,
        refreshToken: response.refreshToken ?? loginData.refreshToken,
        userName: displayUserName,
        userId: response.userId ?? loginData.userId,
        isAdmin: response.isAdmin ?? loginData.isAdmin,
        email: response.email ?? loginData.email,
        isActive: response.isActive ?? loginData.isActive,
        systemGroupName: response.systemGroupName ?? loginData.systemGroupName,
        systemType: response.systemType ?? loginData.systemType,
        sessionId: response.sessionId ?? loginData.sessionId,
        loginDataIdentifier: response.sessionId ?? loginData.loginDataIdentifier ?? "",
      };
      localStorage.setItem("login", JSON.stringify(next));
    } else {
      localStorage.removeItem("login");
      window.location.href = "/login";
      return null;
    }
  } catch (error) {
    console.error("Token refresh failed:", error?.message ?? error);
    localStorage.removeItem("login");
    window.location.href = "/login";
    return null;
  }
}

export default handleRefreshToken;
